import component from './Tag.vue'

export default component
